var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDecisiveness = function SvgDecisiveness(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 88 88"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#105880",
    d: "M72.7 31.5 58 10.5l4.5-3.2 14.7 21-4.5 3.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#105880",
    fillRule: "evenodd",
    d: "M44.6 49 32 31l24-17 12.7 18.1-9.8 6.9 19 27-4.6 3.1-18.9-27-9.8 6.8Zm-5-16.7 15-10.5 6.4 9-15 10.5-6.3-9Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#105880",
    d: "m38.2 55.7-14.7-21 4.5-3.2 14.7 21-4.5 3.2Zm13.1 16H14.7v-5.5h36.6v5.5Zm3.7 9.2H11v-5.5h44v5.5Z"
  })));
};
export default SvgDecisiveness;